<template>
    <div class="content">
        <div class="content-head">
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="处理状态" v-if="isFiltration">
                    <el-select v-model="params.BackBill_Status" placeholder="请选择" class="el-select-medium">
                        <el-option v-for="item in BackBill_Statusopt" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="同步状态" v-if="isFiltration">
                    <el-select v-model="params.BackBill_SyncStatus" placeholder="请选择" class="el-select-medium">
                        <el-option v-for="item in BackBill_SyncStatusopt" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="合同审核状态">
                    <el-select v-model="params.AttachmentAudit" placeholder="请选择" class="el-select-medium">
                        <el-option v-for="item in AttachmentAuditopt" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="RMA状态">
                    <el-select v-model="params.RMAStatus" placeholder="请选择" class="el-select-medium">
                        <el-option v-for="item in RMAStatusopt" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="电子签章状态">
                    <el-select v-model="params.Orders_ESignStatus" placeholder="请选择" class="el-select-medium">
                        <el-option v-for="item in Orders_ESignStatusopt" :key="item.value" :label="item.name" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="业务员">
                    <el-input autocomplete="on" name="officeman"  v-model="params.officeman" placeholder="请输入" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="关键词">
                    <el-input autocomplete="on" name="keyword"  style="width: 220px" v-model="params.keyword" placeholder="输入退货单编号、退货单ERP编号、来源订单号、客户名称进行搜索" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="下单日期" v-if="isFiltration">
                    <el-date-picker v-model="params.date_start" type="date" placeholder="开始日期" value-format="yyyy-MM-dd" clearable></el-date-picker>
                    <span style="margin: 0 5px">至</span>
                    <el-date-picker v-model="params.date_end" type="date" placeholder="结束日期" value-format="yyyy-MM-dd" clearable></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getOrdersBackBills(true)" icon="el-icon-search" :loading="loadingBtn">搜索</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button @click="onRefresh" icon="el-icon-refresh">重置</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button @click="setFiltration" :icon="!isFiltration ? 'el-icon-arrow-down' : 'el-icon-arrow-up'">
                        {{ !isFiltration ? '展开' : '收起' }}
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="content-table">
            <div class="content-table-title">
                退货单列表
                <span>
                    <el-dropdown trigger="click" style="margin-left: 10px; margin-right: 10px">
                        <el-button>
                            导出
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item>
                                <span @click="getPipelineApplysExport()">导出查询信息</span>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </span>
            </div>
            <el-table :data="tableData" :height="maxheight" ref="multipleTable" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }" v-loading="loadingBtn" :row-class-name="tableRowClassName" @row-click="handleRowClick">
                <!-- <el-table-column prop="BackBill_ID" label="ID" width="80" align="center" fixed></el-table-column> -->
                <el-table-column prop="Orders_OfficeMan" label="业务员" show-overflow-tooltip width="120" align="center"></el-table-column>
                <el-table-column prop="BackBill_AddTime" show-overflow-tooltip width="150" label="下单时间" align="center">
                    <template slot-scope="scope">
                        <span>{{ scope.row.BackBill_AddTime | formatDate }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="BackBill_SN" label="退货单编号" show-overflow-tooltip align="center" width="150"></el-table-column>
                <el-table-column prop="BackBill_ERPSN" show-overflow-tooltip width="150" label="退货单ERP编号" align="center"></el-table-column>
                <el-table-column prop="BackBill_OrdersERPSN" show-overflow-tooltip label="来源订单号" align="center" width="120"></el-table-column>
                <el-table-column prop="BackBill_CustomerName" min-width="250" show-overflow-tooltip label="客户" align="center"></el-table-column>
                <el-table-column prop="Orders_ProjectName" show-overflow-tooltip label="工程名称" min-width="250" align="center"></el-table-column>
                <el-table-column prop="BackBill_TotalPrice" show-overflow-tooltip width="150" label="退货单金额" align="center">
                    <template slot-scope="scope">
                        <span>￥{{ scope.row.BackBill_TotalPrice }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="BackBillStatusName" show-overflow-tooltip width="100" label="处理状态" align="center">
                    <template slot-scope="scope">
                        <span>{{ scope.row.BackBillStatusName }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="BackBillSyncStatusName" show-overflow-tooltip width="100" label="同步状态" align="center">
                    <template slot-scope="scope">
                        <span :class="judgeColor(scope.row.BackBillSyncStatusName)">{{ scope.row.BackBillSyncStatusName }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="AttachmentAuditName" width="100" show-overflow-tooltip label="合同审核状态" align="center">
                    <template slot-scope="scope">
                        <span :class="judgeColor(scope.row.AttachmentAuditName)">{{ scope.row.AttachmentAuditName }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="RMAName" width="100" label="RMA状态" show-overflow-tooltip align="center"></el-table-column>
                <el-table-column prop="RecoverStatusName" width="100" show-overflow-tooltip label="合同纸状态" align="center">
                    <template slot-scope="scope">
                        <span :class="judgeColor(scope.row.RecoverStatusName)">{{ scope.row.RecoverStatusName }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="100" fixed="right">
                    <template slot-scope="scope">
                        <div class="operation-bar">
                            <span class="operation-bar-block" @click="handleViewsDetail(scope.row)">查看</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div>
                <Pagination :paginationOptions="paginationOptions" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </div>
        </div>
        <!-- <Returndetails :isdetails="isdetails" :id="id" @handleClose="handleClose"></Returndetails> -->
    </div>
</template>

<script>
import Pagination from '@/components/Pagination.vue';
// import Returndetails from './component/Returndetails.vue';
import { formatDate, downloadFile, toLowerCaseKeys } from '@/utils/utils.js';
import { myMixin } from '@/utils/mixin.js';
export default {
    name: 'returnManagement',
    mixins: [myMixin],
    components: {
        Pagination
        // Returndetails
    },
    data() {
        return {
            id: 0,
            isdetails: false,
            loadingBtn: false,
            params: {
                date_start: '',
                date_end: '',
                BackBill_Status: 0,
                BackBill_SyncStatus: 0,
                AttachmentAudit: 0,
                RMAStatus: 0,
                Orders_ESignStatus: 0,
                officeman: '',
                keyword: ''
            },
            tableData: [],
            BackBill_Statusopt: [
                { value: 0, label: '全部' },
                { value: 1, label: '正常' },
                { value: 2, label: '取消' }
            ],
            BackBill_SyncStatusopt: [
                { value: 0, label: '全部' },
                { value: 1, label: '未同步' },
                { value: 2, label: '主体同步' },
                { value: 3, label: '下达同步' },
                { value: 4, label: '取消同步' }
            ],
            AttachmentAuditopt: [
                { value: 0, label: '全部' },
                { value: '1', label: '待审核' },
                { value: 2, label: '已审核' },
                { value: 3, label: '审核失败' },
                { value: -1, label: '未上传' }
            ],
            RMAStatusopt: [
                { value: 0, label: '全部' },
                { value: 1, label: '未处理' },
                { value: 2, label: '已取消' },
                { value: 3, label: '已部分接收' },
                { value: 4, label: '已完成退出' }
            ],
            Orders_ESignStatusopt: [
                { name: '全部', value: 0 },
                { name: '不需要', value: 1 },
                { name: '电子签章订单', value: -1 },
                { name: '待同步', value: 2 },
                { name: '发送失败', value: 3 },
                { name: '海湾签章失败', value: 4 },
                { name: '待客户签署', value: 5 },
                { name: '客户签署完成', value: 6 },
                { name: '客户拒签', value: 7 },
                { name: '逾期未签署', value: 8 },
                { name: '客户签署失败', value: 9 },
                { name: '已撤回', value: 10 }
            ]
        };
    },
    mounted() {
        // alert('导出接口未开发,查询列表接口RecordCount字段未返回总数,   筛选条件电子签章状态数据',)
        const e = this.$route.query || '';
        if (e) {
            if (e.AttachmentAudit) {
                this.params.AttachmentAudit = e.AttachmentAudit;
            }
        }
        this.getOrdersBackBills();
    },
    methods: {
        //重置
        onRefresh() {
            this.params = {
                date_start: '',
                date_end: '',
                BackBill_Status: 0,
                BackBill_SyncStatus: 0,
                AttachmentAudit: 0,
                RMAStatus: 0,
                Orders_ESignStatus: 0,
                officeman: '',
                keyword: ''
            };
            this.getOrdersBackBills(true);
        },
        handleSizeChange(newSize) {
            this.paginationOptions.PageSize = newSize;
            this.getOrdersBackBills();
        },
        handleCurrentChange(newPage) {
            this.paginationOptions.Page = newPage;
            this.getOrdersBackBills();
        },
        //申请单管理列表
        getOrdersBackBills(flag = false) {
            this.loadingBtn = true;
            if (flag) {
                this.paginationOptions = {
                    Page: 1,
                    total: 0,
                    PageSize: 40
                };
            }
            console.log(this.filteropt(), '===========');
            this.$newsApi
                .getOrdersBackBills(this.filteropt())
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.tableData = res.data.data;
                        this.paginationOptions.total = res.data.RecordCount;
                    }
                })
                .finally(() => (this.loadingBtn = false));
        },
        filteropt() {
            let params = { ...this.params };
            return { json: JSON.stringify(toLowerCaseKeys(params)), Page: this.paginationOptions.Page, PageSize: this.paginationOptions.PageSize };
        },
        //导出所有
        getPipelineApplysExport() {
            this.$newsApi.OrdersBackBill_Export(this.filteropt()).then((res) => {
                if (res.data.Resultcode == 0) {
                    downloadFile(res.data.data, res.data.Resultinfo);
                }
            });
        },
        handleViewsDetail(row) {
            this.id = row.BackBill_ID;
            // this.isdetails = true;
            this.$router.push({ path: '/contractreturnManagement/returnGoodsDetails', query: { id: row.BackBill_ID } });
        },
        handleClose() {
            this.isdetails = false;
        }
    }
};
</script>
<style scoped lang="scss">
.content-head {
    padding: 15px 20px 5px 20px;
}
.el-form-item--small.el-form-item {
    margin-bottom: 5px;
}
</style>